import { Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

interface GiftDefinition {
    eligibleProductId: string;
    freeGiftProductId: string;
    freeGiftIndex: number;
}
interface GiftObject {
    freeGiftId: string | number;
    eligibleProductId: string | number;
    quantity: string | number;
}
@Component
export class FreeGift extends ThemeComponent {

    // @Ref({required: false}) promoBanner!: HTMLElement|null;
    // @Ref({required: false}) promoBanner2!: HTMLElement|null;
    // @Ref({required: false}) autoAdd!: HTMLDivElement|null;
    // @Prop() giftDefinitions!: GiftDefinition[];

    // private giftObject: GiftObject[];
    // private cartUpdating: boolean = false;

    // constructor() {
    //     super();
    //     this.giftObject = [];
    // }

    // init() {
    //     // TODO: This is currently inactive at the client's request.
    //     // Also commented out on cartmain.liquid
    //     this.$subscribe(cart.onChange, throttle(() => {
    //         this.checkCart().catch((err) => { throw new Error; });
    //     }, 1000));
    // }

    // buildCartGiftObject() {
    //     // Get the cart contents
    //     const cartItems = cart.items;
    //     let count = 0;
    //     const giftObject = [];
    //     const definitionsLength = this.giftDefinitions.length;

    //     // For each eligible gift product
    //     for (const eligibleGift of this.giftDefinitions) {
    //         count++;
    //         // Check if the product is in cart
    //         const eligibleProduct = cartItems.find((item) => item.variantId == Number(eligibleGift.eligibleProductId
    //         ));
    //         // If it is, we add the quantity to the free gift data
    //         if (eligibleProduct) {
    //             giftObject.push({
    //                 freeGiftId: Number(eligibleGift.freeGiftProductId),
    //                 eligibleProductId: eligibleGift.eligibleProductId,
    //                 quantity: Number(eligibleProduct.quantity) / Number(eligibleProduct.properties['_pack_size']),
    //                 freeGiftIndex: Number(eligibleGift.freeGiftIndex)
    //             });
    //         } else {
    //             giftObject.push({
    //                 freeGiftId: Number(eligibleGift.freeGiftProductId),
    //                 eligibleProductId: eligibleGift.eligibleProductId,
    //                 quantity: 0,
    //                 freeGiftIndex: Number(eligibleGift.freeGiftIndex)
    //             });
    //         }

    //         if (count == definitionsLength) {
    //             return giftObject;
    //         }
    //     }
    // }

    // async checkCart() {
    //     if (this.cartUpdating || document.body.classList.contains('cart-updating')) {
    //         return;
    //     }

    //     try {

    //         this.cartUpdating = true;
    //         document.body.classList.add('cart-updating');

    //         if (!this.giftDefinitions.length) {
    //             this.promoBanner?.classList.remove('promo--active');
    //             this.promoBanner2?.classList.remove('promo--active');
    //             return;
    //         }

    //         // Get the cart contents
    //         const cartItems = cart.items;
    //         // If there's nothing in cart, bail
    //         if (cartItems.length <= 0) {
    //             this.promoBanner?.classList.remove('promo--active');
    //             this.promoBanner2?.classList.remove('promo--active');
    //             return;
    //         }

    //         const gifts = this.buildCartGiftObject();

    //         if (!gifts) { return; }
    //         const quantities = gifts?.map((item) => item.quantity);
    //         const totalGiftsToAdd = quantities?.reduce(
    //             (prevItem, currentItem) => Number(prevItem) + Number(currentItem));

    //         // If there are no eligble products in cart
    //         if (totalGiftsToAdd == 0) {
    //             this.promoBanner?.classList.remove('promo--active');
    //             this.promoBanner2?.classList.remove('promo--active');
    //             const cartGift = cartItems.find((item) => item.properties && item.properties['_eligibleProductId']);
    //             if (cartGift) {
    //                 // If gift is in cart, check there is an eligible product as well
    //                 const cartEligibleProduct = cartItems.find(
    //                     (item) => {
    //                         item.id == Number(cartGift.properties['_eligibleProductId']);
    //                     }
    //                 );
    //                 if (!cartEligibleProduct) {
    //                     this.removeFreeGift(cartGift).catch((err) => { throw new Error;});
    //                     return;
    //                 }
    //             }

    //         } else {
    //             const gift1Product = gifts.find((gift) => gift.quantity > 0 && gift.freeGiftIndex == 1);

    //             if (gift1Product) {
    //                 this.promoBanner?.classList.add('promo--active');
    //             } else {
    //                 this.promoBanner?.classList.remove('promo--active');
    //             }
    //             const gift2Product = gifts.find((gift) => gift.quantity > 0 && gift.freeGiftIndex == 2);

    //             if (gift2Product) {
    //                 this.promoBanner2?.classList.add('promo--active');
    //             } else {
    //                 this.promoBanner2?.classList.remove('promo--active');
    //             }
    //         }

    //         const promises: Promise<unknown>[] = [];

    //         // Add the gifts to cart
    //         for (const giftProduct of gifts) {

    //             // If the gift is already in cart, get the quantity
    //             const cartGift = cartItems.find((item) => {
    //                 if (item.properties && item.properties['_eligibleProductId']) {
    //                     return item.properties['_eligibleProductId'] == String(giftProduct.eligibleProductId);
    //                 }});

    //             const cartGiftQuantity: number = Number(cartGift?.quantity) || 0;

    //             if (cartGiftQuantity == giftProduct.quantity) {
    //                 continue;
    //             }
    //             // If there's currently no gift in the cart
    //             if (!cartGift) {
    //                 promises.push(cart.addItem({
    //                     id: Number(giftProduct.freeGiftId),
    //                     quantity: Number(giftProduct.quantity),
    //                     properties: {
    //                         // eslint-disable-next-line @typescript-eslint/naming-convention
    //                         _eligibleProductId: String(giftProduct.eligibleProductId)
    //                     }
    //                 }));

    //             } else if (cartGift && Number(giftProduct.quantity) <= 0) {
    //                 // Otherwise if a gift is in cart but the quantity
    //                 // to add is 0 or less than 0
    //                 promises.push(cart.removeItem(
    //                     cartGift
    //                 ));
    //             } else if (cartGift) {
    //                 // Otherwise if a gift is in cart, update it
    //                 promises.push(cart.changeItem(
    //                     cartGift,
    //                     Number(giftProduct.quantity),
    //                     null
    //                 ));
    //             }
    //         }

    //         if (promises.length) {
    //             await Promise.all(promises);
    //         }

    //     } catch(err) {
    //         throw(Error);
    //     } finally {
    //         document.body.classList.remove('cart-updating');
    //         this.cartUpdating = false;
    //     }

    // }

    // async removeFreeGift(cartGift: CartItem) {
    //     await cart.removeItem(
    //         cartGift
    //     ).catch((err) => {
    //         // return err
    //     });
    // }

}
